module.exports = __webpack_public_path__ + "media/images/clickworker_logo_neu-29202a5d7f520b4ce875a335055dc382.png";